import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";
export const linear: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: { src: `${config.ASSETS_URL}/01/15/principle/baffled-circular-dir-lin-ka5-ha2.svg` },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: { src: `${config.ASSETS_URL}/01/15/principle/baffled-circular-coeff-ka5-ha2.svg` },
      },
    },
  },
];
export const logarithmic: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: { src: `${config.ASSETS_URL}/01/15/principle/baffled-circular-dir-db-ka5-ha2.svg` },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: { src: `${config.ASSETS_URL}/01/15/principle/baffled-circular-coeff-ka5-ha2.svg` },
      },
    },
  },
];
